var exports = {
  "N1": "ChannelHeader.module__headerContainer___d1pMan",
  "dL": "ChannelHeader.module__headerWrapper___d1pMan",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___d1pMan",
  "hE": "ChannelHeader.module__headerContainerCallActive___d1pMan",
  "Ud": "ChannelHeader.module__headerLeftSection___d1pMan",
  "Gv": "ChannelHeader.module__backButton___d1pMan",
  "wK": "ChannelHeader.module__backButtonDesktop___d1pMan" + " " + "ChannelHeader.module__backButton___d1pMan",
  "j2": "ChannelHeader.module__backIcon___d1pMan",
  "Ir": "ChannelHeader.module__backIconBold___d1pMan" + " " + "ChannelHeader.module__backIcon___d1pMan",
  "CY": "ChannelHeader.module__leftContentContainer___d1pMan",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___d1pMan",
  "BN": "ChannelHeader.module__mobileButton___d1pMan",
  "Vt": "ChannelHeader.module__desktopButton___d1pMan" + " " + "ChannelHeader.module__mobileButton___d1pMan",
  "R3": "ChannelHeader.module__avatarWrapper___d1pMan",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___d1pMan",
  "_D": "ChannelHeader.module__groupDmHeaderInner___d1pMan",
  "ab": "ChannelHeader.module__groupDmEditIcon___d1pMan",
  "HA": "ChannelHeader.module__channelName___d1pMan",
  "$7": "ChannelHeader.module__groupDmChannelName___d1pMan",
  "kf": "ChannelHeader.module__dmNameWrapper___d1pMan",
  "a1": "ChannelHeader.module__userTag___d1pMan",
  "p": "ChannelHeader.module__channelIcon___d1pMan",
  "ml": "ChannelHeader.module__caretRight___d1pMan",
  "Nj": "ChannelHeader.module__channelInfoContainer___d1pMan",
  "u8": "ChannelHeader.module__followButton___d1pMan",
  "B6": "ChannelHeader.module__topicDivider___d1pMan",
  "zm": "ChannelHeader.module__topicContainer___d1pMan",
  "yu": "ChannelHeader.module__topicButton___d1pMan",
  "Am": "ChannelHeader.module__topicButtonOverflow___d1pMan",
  "lY": "ChannelHeader.module__headerRightSection___d1pMan",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___d1pMan",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___d1pMan",
  "gb": "ChannelHeader.module__iconButton___d1pMan",
  "f5": "ChannelHeader.module__iconButtonDefault___d1pMan" + " " + "ChannelHeader.module__iconButton___d1pMan",
  "vR": "ChannelHeader.module__iconButtonSelected___d1pMan" + " " + "ChannelHeader.module__iconButton___d1pMan",
  "rB": "ChannelHeader.module__updateIconButton___d1pMan" + " " + "ChannelHeader.module__iconButton___d1pMan",
  "l_": "ChannelHeader.module__updateIcon___d1pMan",
  "Do": "ChannelHeader.module__updateIconSpinning___d1pMan" + " " + "ChannelHeader.module__updateIcon___d1pMan",
  "bx": "ChannelHeader.module__updateIconSpin___d1pMan",
  "IC": "ChannelHeader.module__iconButtonMobile___d1pMan",
  "iA": "ChannelHeader.module__buttonIcon___d1pMan",
  "qt": "ChannelHeader.module__buttonIconMobile___d1pMan",
  "Dm": "ChannelHeader.module__iconButtonWrapper___d1pMan",
  "W9": "ChannelHeader.module__unreadPinIndicator___d1pMan",
};

module.exports = exports;
